/** Shared weekday/Fri–Sun rate lookup for the calendar and the summary. */
(() => {
  if (window.ReservationRateUtils) return;

  const CENTS_PER_UNIT = 100;

  const findVariant = (variants, variantId) =>
    (variants || []).find((variant) => Number(variant.id) === Number(variantId)) || null;

  /**
   * Weekday and Fri–Sun siblings of this duration + suite count.
   * Null without Hours — matching on empty would pick any duration.
   */
  const resolveDayTypePair = (variants, variantId) => {
    const current = findVariant(variants, variantId);
    if (!current || !current.hours) return null;

    const sameOptions = (variant) =>
      String(variant.hours) === String(current.hours) &&
      String(variant.suites) === String(current.suites);

    return {
      current,
      hours: parseFloat(current.hours) || 0,
      weekday: variants.find((variant) => variant.day_type === 'weekday' && sameOptions(variant)) || null,
      weekend: variants.find((variant) => variant.day_type === 'weekend' && sameOptions(variant)) || null
    };
  };

  const formatMoney = (cents) => {
    if (window.theme?.Currency?.formatMoney && window.shopSettings?.moneyFormat) {
      return window.theme.Currency.formatMoney(Math.round(cents), window.shopSettings.moneyFormat);
    }
    return `$${(cents / CENTS_PER_UNIT).toFixed(2)}`;
  };

  /** Drop .00 so the rate fits a calendar cell. */
  const formatMoneyShort = (cents) => formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');

  const formatHours = (value) => {
    const hours = parseFloat(value);
    if (!Number.isFinite(hours)) return '';
    return `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
  };

  window.ReservationRateUtils = {
    findVariant,
    resolveDayTypePair,
    formatMoney,
    formatMoneyShort,
    formatHours
  };
})();
